/* KAWAGUCHI DEV */
(function() {
  'use strict';
  
  // 初期化済みフラグ
  if (window.freeShippingBarInitialized) {
    return;
  }
  window.freeShippingBarInitialized = true;

  const threshold = 1500000;
  
  function updateShippingBar() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const total = cart.total_price;
        const remaining = threshold - total;
        const percentage = Math.min((total / threshold) * 100, 100);
        
        const textEl = document.querySelector('.free-shipping-bar__text');
        const fillEl = document.querySelector('.free-shipping-bar__progress-fill');
        
        if (textEl && fillEl) {
          if (remaining > 0) {
            const remainingYen = Math.ceil(remaining / 100);
            textEl.textContent = 'あと ¥' + remainingYen.toLocaleString('ja-JP') + ' で送料無料になります。';
          } else {
            textEl.textContent = '送料無料です';
          }
          
          fillEl.style.width = percentage + '%';
        }
      })
      .catch(error => {
        console.error('Cart update error:', error);
      });
  }
  
  function syncGiftContainerWidth() {
    const giftContainer = document.querySelector('.sns-gift-new-cart-container');
    const summaryWrapper = document.querySelector('.ajax-cart__summary-wrapper');
    
    if (giftContainer && summaryWrapper) {
      const summaryWidth = summaryWrapper.offsetWidth;
      giftContainer.style.width = summaryWidth + 'px';
      giftContainer.style.flexShrink = '0';
    }
  }

  // 初期化
  function init() {
    updateShippingBar();
    syncGiftContainerWidth();
  }

  // イベントリスナー（1回のみ）
  document.addEventListener('cart:updated', () => {
    updateShippingBar();
    setTimeout(syncGiftContainerWidth, 100);
  });

  window.addEventListener('resize', syncGiftContainerWidth);

  // 定期更新
  setInterval(updateShippingBar, 3000);
  setInterval(syncGiftContainerWidth, 3000);
  setInterval(toggleNgcAttrFields, 2000);

  // 初期化実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
